import { APP_NAME } from "../../config/brand";
import styles from "./brandLockup.module.css";

/** Official wordmark: The (42% ink) + RallyAlly — no spaces. */
export default function TRABrandWordmark({ className = "" }) {
  return (
    <span
      className={`tra-brand-wordmark ${styles.wordmark}${className ? ` ${className}` : ""}`}
      data-tra-text-bold="brand"
      aria-label={APP_NAME}
    >
      <span className={`${styles.wordmarkThe} tra-brand-wordmark-the`}>The</span>RallyAlly
    </span>
  );
}
